<template>
  <div>
    <app-page-container extra :min-height="200">
      <app-flex-grid :rows="[['240px', '220px']]">
        <template #col-1-1>
          <app-input
            @input.native="onReservationSearch"
            v-model="search"
            type="search"
            placeholder="Search by client, lead number"
            name="search"
          />
        </template>
        <template #col-1-2>
          <app-select
            @input="onChangeCategory"
            v-model="reservation_manager"
            :options="reservation_manager_options"
            :reduce="item => item.id"
            :filterable="false"
            :searchable="false"
            label="full_name"
            placeholder="Reservation manager"
          />
        </template>
      </app-flex-grid>
      <app-spinner v-if="!is_loaded" />
      <template v-else>
        <AppAccFlight
          v-for="(reservation, index) in reservations"
          :key="reservation.id"
          :reservation="reservation"
          :order-number="index + 1"
        />
        <app-cells :position="pagination.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records :all="pagination.count" :count="reservations.length" :page="pagination.page" />
        </app-cells>
      </template>
    </app-page-container>
  </div>
</template>

<script>
import { getReservationsFlights, getUsers } from '@/http'
import AppAccFlight from '@/components/AppAccFlight.vue'
import debounce from 'lodash/debounce'

export default {
  name: 'FlightsReservationsListArchive',
  components: { AppAccFlight },
  data() {
    return {
      is_loaded: false,
      reservations: [],
      search: null,
      reservation_manager: null,
      reservation_manager_options: [],
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created() {
    this.fetchItems()
    getUsers({ is_active: true, group: 'reservation_supervisor,reservation_manager,reservation_supervisor' })
      .then(res => { this.reservation_manager_options = res.data })
  },
  methods: {
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    fetchItems() {
      getReservationsFlights({
        category: 'archive',
        reservation_status: 'booked',
        reservation_manager: this.search ? '' : this.reservation_manager,
        search: this.search,
        page: this.pagination.page,
        page_size: 20,
      })
        .then(res => {
          this.reservations = res.data.results
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count
          this.is_loaded = true
        })
    },
    onReservationSearch() {
      this.reservation_manager = ''
      this.searchReservation(this)
      this.is_loaded = false
    },
    searchReservation: debounce(vm => {
      vm.fetchItems()
    }, 350),
    onChangeCategory() {
      this.is_loaded = false
      this.search = ''
      this.fetchItems()
    },
  }
}
</script>
